export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "regexTester": {
    "title": "正则表达式测试器",
    "subtitle": "实时测试正则表达式。匹配、高亮、复制。",
    "privacy": "100% 本地处理",
    "quickPatterns": "常用模式",
    "pattern": "正则模式",
    "patternPlaceholder": "输入正则表达式...",
    "flags": "标志",
    "testText": "测试文本",
    "testPlaceholder": "输入要测试的文本...",
    "matches": "匹配",
    "match": "匹配项",
    "index": "位置",
    "length": "长度",
    "groups": "捕获组",
    "noMatches": "未找到匹配"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有正则表达式测试均在您的浏览器本地完成。您的模式和测试字符串绝不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用正则表达式测试器",
      "description": "使用匹配高亮、分组提取和替换预览功能，实时测试正则表达式。",
      "steps": [
        {
          "title": "输入正则表达式模式",
          "description": "在模式字段中输入正则表达式。使用标志下拉菜单设置全局、不区分大小写、多行和点匹配所有模式。"
        },
        {
          "title": "添加测试文本",
          "description": "在输入面板中粘贴或键入要测试的文本。输入时会实时高亮显示匹配项。"
        },
        {
          "title": "查看匹配和分组",
          "description": "检查每个匹配项、捕获的分组和匹配位置。使用替换选项卡预览替换结果，然后再应用。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "实时正则表达式匹配，支持语法高亮",
        "支持所有标准 JavaScript 正则表达式标志",
        "提取并显示捕获的分组",
        "显示匹配位置和长度信息",
        "替换预览，显示替换结果",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的正则表达式数据会被发送到服务器吗？",
          "answer": "不会。所有模式匹配均在您的浏览器内使用原生 JavaScript RegExp 引擎完成。您的模式和测试字符串绝不会离开您的设备。"
        },
        {
          "question": "使用哪种正则表达式风格？",
          "answer": "测试器使用标准 JavaScript RegExp 引擎（ECMAScript）。这与 Node.js、Chrome、Firefox 和 Safari 中的正则表达式行为一致。"
        },
        {
          "question": "为什么我的正则表达式显示没有匹配？",
          "answer": "常见问题包括缺少标志（例如需要 /i 时使用了区分大小写匹配）、未转义的特殊字符，或不正确的锚定（^ 和 $）。请查看语法参考以获取帮助。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "Cron 解析器",
          "url": "/developer/cron-parser",
          "description": "将标准 Cron 表达式解析为人类可读的计划。"
        },
        {
          "name": "JSON 格式化工具",
          "url": "/formatter/json-formatter",
          "description": "格式化、验证并美化 JSON 数据，支持语法高亮。"
        },
        {
          "name": "大小写转换器",
          "url": "/text/case-converter",
          "description": "在大小写、小写、camelCase、snake_case 等之间转换文本。"
        }
      ]
    }
  }
};
